export default __webpack_public_path__ + "0988f46fac5e95a04b56cb3fc4880310.jpeg";